import {
  Box,
  Button,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Flex,
  Heading,
  ListItem,
  Text,
  UnorderedList,
} from "@chakra-ui/react";
import { isMobile } from "react-device-detect";

export interface CustomTestWelcomePageProps {
  onNextClicked: () => void;
}
function CustomTestWelcomePage(props: CustomTestWelcomePageProps) {
  return (
    <Flex
      justifyContent={"center"}
      margin={isMobile ? "1rem" : "0rem"}
    >
      <Card
        boxShadow={"none"}
        bg={"#35373f"}
        justifySelf={"center"}
        height={"auto"}
        marginTop={isMobile ? "0" : "4rem"}
        width={isMobile ? "100" : "70%"}
        borderLeft={"4px"}
        borderLeftColor={"#f56565"}
      >
        <CardHeader>
          <Box alignSelf="start">
            <Heading
              mt={"1rem"}
              color="#3acad3"
              textAlign={"center"}
              size={"lg"}
              fontWeight={"semibold"}
              style={{
                fontVariant: "small-caps",
              }}
            >
              Welcome to Your ControlReady™ Assessment
            </Heading>
          </Box>
        </CardHeader>
        <CardBody>
          <Text
            fontSize={isMobile ? "md" : "lg"}
            fontFamily={"sans-serif"}
            color="#bbbbbb"
            textAlign={"left"}
            mb={"1rem"}
          >
            Thank you for taking the time to complete this first stage of the
            process.
          </Text>
          <Text
            fontSize={isMobile ? "md" : "lg"}
            fontFamily={"sans-serif"}
            color="#bbbbbb"
            textAlign={"left"}
            mb={"1rem"}
          >
            This assessment consists of 74 questions and should take around 30
            minutes to complete. Please set aside enough uninterrupted time
            before you begin.
          </Text>
          <Text
            fontSize={isMobile ? "md" : "lg"}
            fontFamily={"sans-serif"}
            color="#bbbbbb"
            textAlign={"left"}
            mb={"0.5rem"}
          >
            A few things to keep in mind:
          </Text>
          <UnorderedList
            spacing={3}
            fontSize={isMobile ? "md" : "lg"}
            fontFamily={"sans-serif"}
            color="#bbbbbb"
            textAlign={"left"}
            pl={"1rem"}
            mb={"1rem"}
          >
            <ListItem>
              There are no trick questions. Read each one carefully and respond
              based on what feels most true for you - not what you think the
              "right" answer should be.
            </ListItem>
            <ListItem>
              Work at a steady pace. There is no time limit, but most people
              complete this in one sitting without stopping.
            </ListItem>
            <ListItem>
              Your responses are confidential. They will only be used as part of
              the ControlReady™ assessment process for this role.
            </ListItem>
            <ListItem>
              Once you begin, please complete the assessment in full. If you
              close the page before finishing, you may not be able to return to
              where you left off.
            </ListItem>
          </UnorderedList>
          <Text
            fontSize={isMobile ? "md" : "lg"}
            fontFamily={"sans-serif"}
            color="#bbbbbb"
            textAlign={"left"}
          >
            When you are ready, click Begin below.
          </Text>
        </CardBody>
        <CardFooter justifyContent={"center"}>
          <Button
            justifyContent={"center"}
            padding={"0rem 2rem"}
            size={isMobile ? "md" : "lg"}
            fontSize={isMobile ? "md" : "lg"}
            onClick={props.onNextClicked}
          >
            Begin
          </Button>
        </CardFooter>
      </Card>
    </Flex>
  );
}

export default CustomTestWelcomePage;
